export default "__VITE_ASSET__AIXbtopo__"